import React from 'react';
import { Button, Chip, Divider, Grid, Stack, Typography } from '@mui/material';
import { CheckCircle as CheckIcon, Shield as ShieldIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

export default function LandingFooter() {
    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Typography variant="h6" fontWeight={800}>
                        Schreiberlein
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1.25 }}>
                        Die einfache Lösung für deine Buchhaltung. Schreibe Rechnungen, erfasse Belege und behalte den Überblick – ohne
                        Excel-Chaos.
                    </Typography>
                    <Stack direction="row" gap={1.5} sx={{ mt: 2 }}>
                        <Chip icon={<CheckIcon />} label="Made in EU" variant="outlined" size="small" />
                        <Chip icon={<ShieldIcon />} label="DSGVO" variant="outlined" size="small" />
                    </Stack>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        Schnellzugriff
                    </Typography>
                    <Stack direction="row" gap={1} flexWrap="wrap">
                        <Button component={RouterLink} to="/registration" size="small">
                            Registrieren
                        </Button>
                        <Button component={RouterLink} to="/login" size="small">
                            Login
                        </Button>
                        <Button component={RouterLink} to="/invoices" size="small">
                            Rechnung erstellen
                        </Button>
                        <Button component={RouterLink} to="/expenses" size="small">
                            Ausgaben
                        </Button>
                        <Button component={RouterLink} to="/evaluation" size="small">
                            Auswertungen
                        </Button>
                        <Button component={RouterLink} to="/terms" size="small">
                            AGB
                        </Button>
                        <Button component={RouterLink} to="/imprint" size="small">
                            Impressum
                        </Button>
                        <Button component={RouterLink} to="/privacy" size="small">
                            Datenschutz
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
            <Divider sx={{ my: 3 }} />
            <Typography variant="caption" color="text.secondary">
                © {new Date().getFullYear()} Schreiberlein. Alle Rechte vorbehalten.
            </Typography>
        </>
    );
}
